import { render, staticRenderFns } from "./privacyAgreementAdd.vue?vue&type=template&id=21f1188a"
import script from "./privacyAgreementAdd.vue?vue&type=script&lang=js"
export * from "./privacyAgreementAdd.vue?vue&type=script&lang=js"
import style0 from "./privacyAgreementAdd.vue?vue&type=style&index=0&id=21f1188a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports